import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { 
  getTodosUsuarios, 
  crearUsuario, 
  actualizarUsuario, 
  eliminarUsuario, 
  resetearContrasenaUsuario,
  getTodasAreas 
} from '../../actions';
import './GestionUsuariosPage.css';

// react-select (multi) con la paleta moderna oscura + verde
const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#0A100D',
    borderColor: state.isFocused ? 'rgba(40,199,111,0.6)' : 'rgba(255,255,255,0.10)',
    borderWidth: '0.5px',
    borderRadius: '10px',
    color: '#E8EFEA',
    minHeight: '42px',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(40,199,111,0.20)' : 'none',
    '&:hover': { borderColor: 'rgba(40,199,111,0.45)' }
  }),
  menu: (provided) => ({ ...provided, backgroundColor: '#0C120F', border: '0.5px solid rgba(40,199,111,0.25)', borderRadius: '11px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.6)', zIndex: 9999 }),
  menuList: (provided) => ({ ...provided, padding: '6px', maxHeight: '230px' }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'rgba(40,199,111,0.16)' : state.isFocused ? 'rgba(40,199,111,0.12)' : 'transparent',
    color: state.isSelected || state.isFocused ? '#EAF6EF' : '#CBD6CF',
    borderRadius: '8px', padding: '9px 11px', cursor: 'pointer',
  }),
  placeholder: (provided) => ({ ...provided, color: '#9FB0A6', fontSize: 13 }),
  input: (provided) => ({ ...provided, color: '#E8EFEA' }),
  valueContainer: (provided) => ({ ...provided, padding: '4px 8px', gap: '4px' }),
  multiValue: (provided) => ({ ...provided, backgroundColor: 'rgba(40,199,111,0.14)', borderRadius: '999px' }),
  multiValueLabel: (provided) => ({ ...provided, color: '#3FE07F', fontSize: 12, padding: '2px 4px 2px 8px' }),
  multiValueRemove: (provided) => ({ ...provided, color: '#3FE07F', borderRadius: '999px', ':hover': { backgroundColor: 'rgba(40,199,111,0.25)', color: '#EAF6EF' } }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided, state) => ({ ...provided, color: state.isFocused ? '#3FE07F' : '#5C6862', ':hover': { color: '#3FE07F' } }),
  clearIndicator: (provided) => ({ ...provided, color: '#9FB0A6', ':hover': { color: '#E86D6D' } }),
};

const GestionUsuariosPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const usuarios = useSelector(state => state.usuarios);
  const areas = useSelector(state => state.Repoteareas);
  
  const [vistaActual, setVistaActual] = useState('lista');
  const [usuarioEditando, setUsuarioEditando] = useState(null);
  const [mostrarModalPassword, setMostrarModalPassword] = useState(false);
  const [usuarioParaReset, setUsuarioParaReset] = useState(null);
  const [nuevaContrasena, setNuevaContrasena] = useState('');
  const [contrasenaPersonalizada, setContrasenaPersonalizada] = useState(false);
  const [mostrarContrasena, setMostrarContrasena] = useState(false);
  const [resetExitoso, setResetExitoso] = useState(false);
  const [contrasenaFinal, setContrasenaFinal] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [formulario, setFormulario] = useState({
    nombre: '',
    apellidos: '',
    email: '',
    perfil: '',
    contrasena: '',
    estado: true,
    Areas: []
  });

  const perfilesDisponibles = [
    "Socio",
    "Gerente", 
    "Responsable",
    "Analista Sr",
    "Analista SSr",
    "Analista",
    "Administrador del sistema"
  ];

  useEffect(() => {
    dispatch(getTodosUsuarios());
    dispatch(getTodasAreas());
  }, [dispatch]);

  // Extraer array de áreas del estado (igual que en el componente original)
  const areasArray = areas?.areas || [];
  
  console.log('Areas disponibles:', areasArray);
  
  // Preparar opciones para react-select
  const opcionesAreas = areasArray.map(area => ({
    value: area.id,
    label: area.nombre
  }));
  
  console.log('Opciones para react-select:', opcionesAreas);

  // Filtrar usuarios según la búsqueda
  const usuariosFiltrados = usuarios ? usuarios.filter(usuario => {
    if (!busqueda.trim()) return true;
    
    const terminoBusqueda = busqueda.toLowerCase().trim();
    const nombreCompleto = `${usuario.nombre} ${usuario.apellidos}`.toLowerCase();
    const email = usuario.email.toLowerCase();
    
    return nombreCompleto.includes(terminoBusqueda) || 
           email.includes(terminoBusqueda) ||
           usuario.nombre.toLowerCase().includes(terminoBusqueda) ||
           usuario.apellidos.toLowerCase().includes(terminoBusqueda);
  }) : [];

  const limpiarFormulario = () => {
    setFormulario({
      nombre: '',
      apellidos: '',
      email: '',
      perfil: '',
      contrasena: '',
      estado: true,
      Areas: []
    });
    setUsuarioEditando(null);
  };

  const manejarCambio = (e) => {
    const { name, value, type, checked } = e.target;
    setFormulario(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const manejarCambioAreas = (areasSeleccionadas) => {
    console.log('Areas seleccionadas desde react-select:', areasSeleccionadas);
    
    // areasSeleccionadas viene como array de objetos {value, label} desde react-select
    const areasFormateadas = areasSeleccionadas ? areasSeleccionadas.map(area => {
      // Buscar el área completa en areasArray para tener toda la información
      const areaCompleta = areasArray.find(a => a.id === area.value);
      return {
        id: area.value,
        nombre: area.label,
        value: area.value,
        label: area.label,
        // Incluir cualquier otra propiedad que pueda tener el área
        ...areaCompleta
      };
    }) : [];
    
    console.log('Areas formateadas para el formulario:', areasFormateadas);
    
    setFormulario(prev => ({
      ...prev,
      Areas: areasFormateadas
    }));
  };

  const manejarSubmit = async (e) => {
    e.preventDefault();
    
    // Validar contraseña solo al crear usuario nuevo
    if (!usuarioEditando) {
      if (!formulario.contrasena.trim()) {
        alert('La contraseña es obligatoria para crear un usuario nuevo');
        return;
      }
      if (formulario.contrasena.length < 6) {
        alert('La contraseña debe tener al menos 6 caracteres');
        return;
      }
    }
    
    console.log('Formulario completo antes de enviar:', formulario);
    console.log('Areas en formulario:', formulario.Areas);
    
    const areasIds = formulario.Areas.map(area => area.id || area.value);
    console.log('IDs de areas extraídos:', areasIds);
    
    const datosUsuario = {
      nombre: formulario.nombre,
      apellidos: formulario.apellidos,
      email: formulario.email,
      perfil: formulario.perfil,
      estado: formulario.estado,
      Areas: areasIds
    };

    // Solo incluir contraseña al crear usuario nuevo
    if (!usuarioEditando) {
      datosUsuario.contrasena = formulario.contrasena;
    }

    console.log('Datos del usuario a enviar:', datosUsuario);

    try {
      let resultado;
      if (usuarioEditando) {
        resultado = await dispatch(actualizarUsuario(usuarioEditando.id, datosUsuario));
        if (resultado.success) {
          alert('Usuario actualizado correctamente');
        } else {
          throw new Error(resultado.error);
        }
      } else {
        resultado = await dispatch(crearUsuario(datosUsuario));
        if (resultado.success) {
          alert('Usuario creado correctamente');
        } else {
          throw new Error(resultado.error);
        }
      }
      
      limpiarFormulario();
      setVistaActual('lista');
      dispatch(getTodosUsuarios());
    } catch (error) {
      console.error('Error al guardar usuario:', error);
      alert('Error al guardar el usuario: ' + (error.message || 'Error desconocido'));
    }
  };

  const editarUsuario = (usuario) => {
    setUsuarioEditando(usuario);
    setFormulario({
      nombre: usuario.nombre,
      apellidos: usuario.apellidos,
      email: usuario.email,
      perfil: usuario.perfil,
      contrasena: '', // No mostrar contraseña al editar
      estado: usuario.estado,
      Areas: usuario.areas?.map(area => ({
        id: area.id,
        nombre: area.nombre,
        value: area.id,
        label: area.nombre
      })) || []
    });
    setVistaActual('formulario');
  };

  const eliminarUsuarioHandler = async (id) => {
    const confirmacion = window.confirm('¿Estás seguro de que deseas eliminar este usuario? Esta acción no se puede revertir.');

    if (confirmacion) {
      try {
        await dispatch(eliminarUsuario(id));
        alert('Usuario eliminado correctamente');
        dispatch(getTodosUsuarios());
      } catch (error) {
        alert('Error al eliminar el usuario');
      }
    }
  };

  const abrirModalResetPassword = (usuario) => {
    setUsuarioParaReset(usuario);
    generarNuevaContrasena();
    setMostrarModalPassword(true);
  };

  const generarNuevaContrasena = () => {
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
    let contrasena = '';
    for (let i = 0; i < 12; i++) {
      contrasena += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
    }
    setNuevaContrasena(contrasena);
  };

  const copiarContrasena = () => {
    navigator.clipboard.writeText(nuevaContrasena);
    alert('Contraseña copiada al portapapeles');
  };

  const confirmarResetPassword = async () => {
    if (!nuevaContrasena.trim()) {
      alert('La contraseña no puede estar vacía');
      return;
    }
    
    if (nuevaContrasena.length < 6) {
      alert('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    try {
      const resultado = await dispatch(resetearContrasenaUsuario(usuarioParaReset.id, nuevaContrasena));
      
      if (resultado.success) {
        // Guardar la contraseña para mostrarla después del reset
        setContrasenaFinal(nuevaContrasena);
        setResetExitoso(true);
      } else {
        throw new Error(resultado.error);
      }
    } catch (error) {
      console.error('Error al resetear contraseña:', error);
      alert('Error al resetear la contraseña: ' + (error.message || 'Error desconocido'));
    }
  };

  const cerrarModalPassword = () => {
    setMostrarModalPassword(false);
    setUsuarioParaReset(null);
    setNuevaContrasena('');
    setContrasenaPersonalizada(false);
    setMostrarContrasena(false);
    setResetExitoso(false);
    setContrasenaFinal('');
  };

  return (
    <div className="gestion-usuarios-page">
      <div className="gestion-usuarios-header">
        <div className="header-content">
          <button 
            className="btn-volver"
            onClick={() => history.push('/home')}
          >
            ← Volver
          </button>
          <h2>Gestión de Usuarios</h2>
        </div>
      </div>

      <div className="gestion-usuarios-nav">
        <button 
          className={`nav-btn ${vistaActual === 'lista' ? 'active' : ''}`}
          onClick={() => {
            setVistaActual('lista');
            limpiarFormulario();
          }}
        >
          Lista de Usuarios
        </button>
        <button 
          className={`nav-btn ${vistaActual === 'formulario' ? 'active' : ''}`}
          onClick={() => {
            setVistaActual('formulario');
            limpiarFormulario();
          }}
        >
          {usuarioEditando ? 'Editar Usuario' : 'Crear Usuario'}
        </button>
      </div>

      {vistaActual === 'lista' && (
        <div className="usuarios-content">
          <div className="usuarios-search-container">
            <div className="search-input-group">
              <span className="search-icon">🔍</span>
              <input
                type="text"
                className="usuarios-search-input"
                placeholder="Buscar usuarios por nombre, apellido o email..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
              />
              {busqueda && (
                <button 
                  className="search-clear-btn"
                  onClick={() => setBusqueda('')}
                  title="Limpiar búsqueda"
                >
                  ✕
                </button>
              )}
            </div>
            {busqueda && (
              <div className="search-results-info">
                Mostrando {usuariosFiltrados.length} de {usuarios?.length || 0} usuarios
              </div>
            )}
          </div>
          <div className="usuarios-tabla-container">
            <table className="usuarios-tabla">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Apellidos</th>
                  <th>Email</th>
                  <th>Perfil</th>
                  <th>Áreas</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {!usuarios || usuarios.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="no-usuarios">
                      {usuarios === null || usuarios === undefined ? 'Cargando usuarios...' : 'No hay usuarios registrados'}
                    </td>
                  </tr>
                ) : usuariosFiltrados.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="no-usuarios">
                      {busqueda ? `No se encontraron usuarios que coincidan con "${busqueda}"` : 'No hay usuarios registrados'}
                    </td>
                  </tr>
                ) : (
                  usuariosFiltrados.map(usuario => (
                  <tr key={usuario.id}>
                    <td>{usuario.id}</td>
                    <td>{usuario.nombre}</td>
                    <td>{usuario.apellidos}</td>
                    <td>{usuario.email}</td>
                    <td>
                      <span className="perfil-badge">
                        {usuario.perfil}
                      </span>
                    </td>
                    <td>
                      <div className="areas-badges">
                        {usuario.areas?.map(area => (
                          <span key={area.id} className="area-badge">
                            {area.nombre}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td>
                      <span className={`estado-badge ${usuario.estado ? 'activo' : 'inactivo'}`}>
                        {usuario.estado ? 'Activo' : 'Inactivo'}
                      </span>
                    </td>
                    <td>
                      <div className="acciones-buttons">
                        <button 
                          className="btn-editar"
                          onClick={() => editarUsuario(usuario)}
                          title="Editar usuario"
                        >
                          ✏️
                        </button>
                        <button 
                          className="btn-resetear"
                          onClick={() => abrirModalResetPassword(usuario)}
                          title="Resetear contraseña"
                        >
                          🔑
                        </button>
                        <button 
                          className="btn-eliminar"
                          onClick={() => eliminarUsuarioHandler(usuario.id)}
                          title="Eliminar usuario"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {vistaActual === 'formulario' && (
        <div className="usuario-formulario">
          <h3>{usuarioEditando ? 'Editar Usuario' : 'Crear Nuevo Usuario'}</h3>
          
          <form onSubmit={manejarSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nombre">Nombre *</label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formulario.nombre}
                  onChange={manejarCambio}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="apellidos">Apellidos *</label>
                <input
                  type="text"
                  id="apellidos"
                  name="apellidos"
                  value={formulario.apellidos}
                  onChange={manejarCambio}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formulario.email}
                  onChange={manejarCambio}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="perfil">Perfil *</label>
                <select
                  id="perfil"
                  name="perfil"
                  value={formulario.perfil}
                  onChange={manejarCambio}
                  required
                >
                  <option value="">Seleccionar perfil</option>
                  {perfilesDisponibles.map(perfil => (
                    <option key={perfil} value={perfil}>{perfil}</option>
                  ))}
                </select>
              </div>
            </div>

            {!usuarioEditando && (
              <div className="form-group">
                <label htmlFor="contrasena">Contraseña *</label>
                <input
                  type="password"
                  id="contrasena"
                  name="contrasena"
                  value={formulario.contrasena}
                  onChange={manejarCambio}
                  required={!usuarioEditando}
                  placeholder="Mínimo 6 caracteres"
                />
              </div>
            )}

            <div className="form-group">
              <label>Áreas Asignadas</label>
              <Select
                isMulti
                value={formulario.Areas.map(area => ({
                  value: area.id || area.value,
                  label: area.nombre || area.label
                }))}
                onChange={manejarCambioAreas}
                options={opcionesAreas}
                styles={customSelectStyles}
                className="react-select-container"
                classNamePrefix="repms"
                placeholder="Seleccionar áreas..."
                noOptionsMessage={() => "No hay áreas disponibles"}
                isSearchable={true}
                isClearable={true}
                closeMenuOnSelect={false}
              />
              <small className="form-help">
                Puedes buscar y seleccionar múltiples áreas. 
                {usuarioEditando && ' Las áreas ya asignadas aparecen seleccionadas.'}
              </small>
            </div>

            <div className="form-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="estado"
                  checked={formulario.estado}
                  onChange={manejarCambio}
                />
                Usuario activo
              </label>
            </div>

            <div className="form-actions">
              <button 
                type="button" 
                className="btn-cancelar"
                onClick={() => {
                  limpiarFormulario();
                  setVistaActual('lista');
                }}
              >
                Cancelar
              </button>
              <button type="submit" className="btn-guardar">
                {usuarioEditando ? 'Actualizar' : 'Crear'} Usuario
              </button>
            </div>
          </form>
        </div>
      )}

      {mostrarModalPassword && (
        <div className="password-modal-overlay">
          <div className="password-modal">
            <div className="password-modal-header">
              <h3>{resetExitoso ? 'Contraseña Reseteada' : 'Resetear Contraseña'}</h3>
              <button 
                className="btn-close-modal"
                onClick={cerrarModalPassword}
              >
                ×
              </button>
            </div>
            
            <div className="password-modal-body">
              <p>Usuario: <strong>{usuarioParaReset?.nombre} {usuarioParaReset?.apellidos}</strong></p>
              <p>Email: <strong>{usuarioParaReset?.email}</strong></p>
              
              {resetExitoso ? (
                <div className="password-success">
                  <div className="success-message">
                    <span className="success-icon">✅</span>
                    <p>La contraseña ha sido actualizada correctamente</p>
                  </div>
                  
                  <div className="password-field-container">
                    <label htmlFor="contrasena-final">Nueva Contraseña Asignada:</label>
                    <div className="password-input-group">
                      <input
                        type="text"
                        id="contrasena-final"
                        className="password-input"
                        value={contrasenaFinal}
                        readOnly
                      />
                      <button 
                        type="button"
                        className="btn-copy-password"
                        onClick={() => {
                          navigator.clipboard.writeText(contrasenaFinal);
                          alert('Contraseña copiada al portapapeles');
                        }}
                        title="Copiar contraseña"
                      >
                        📋
                      </button>
                    </div>
                    <div className="password-help-container">
                      <small>Copia esta contraseña y compártela con el usuario de forma segura</small>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="password-field-container">
                  <label htmlFor="nueva-contrasena">Nueva Contraseña:</label>
                  <div className="password-input-group">
                    <input
                      type={contrasenaPersonalizada ? (mostrarContrasena ? "text" : "password") : "text"}
                      id="nueva-contrasena"
                      className="password-input"
                      value={nuevaContrasena}
                      onChange={(e) => setNuevaContrasena(e.target.value)}
                      readOnly={!contrasenaPersonalizada}
                      placeholder={contrasenaPersonalizada ? "Escribe la nueva contraseña (min. 6 caracteres)" : ""}
                    />
                    {contrasenaPersonalizada ? (
                      <button 
                        type="button"
                        className="btn-toggle-visibility"
                        onClick={() => setMostrarContrasena(!mostrarContrasena)}
                        title={mostrarContrasena ? "Ocultar contraseña" : "Mostrar contraseña"}
                      >
                        {mostrarContrasena ? '👁️‍🗨️' : '👁️'}
                      </button>
                    ) : (
                      <button 
                        type="button"
                        className="btn-copy-password"
                        onClick={copiarContrasena}
                        title="Copiar contraseña"
                      >
                        📋
                      </button>
                    )}
                  </div>
                  
                  <div className="password-actions">
                    <button 
                      type="button"
                      className={`btn-password-mode ${!contrasenaPersonalizada ? 'active' : ''}`}
                      onClick={() => {
                        setContrasenaPersonalizada(false);
                        setMostrarContrasena(false);
                        generarNuevaContrasena();
                      }}
                    >
                      🎲 Generar
                    </button>
                    <button 
                      type="button"
                      className={`btn-password-mode ${contrasenaPersonalizada ? 'active' : ''}`}
                      onClick={() => {
                        setContrasenaPersonalizada(true);
                        setNuevaContrasena('');
                        setMostrarContrasena(false);
                      }}
                    >
                      ✏️ Personalizada
                    </button>
                  </div>
                  
                  <div className="password-help-container">
                    {contrasenaPersonalizada && (
                      <small>La contraseña debe tener al menos 6 caracteres</small>
                    )}
                  </div>
                </div>
              )}
            </div>
            
            <div className="password-modal-footer">
              {resetExitoso ? (
                <button 
                  className="btn-confirm-password"
                  onClick={cerrarModalPassword}
                >
                  Cerrar
                </button>
              ) : (
                <>
                  <button 
                    className="btn-cancel-password"
                    onClick={cerrarModalPassword}
                  >
                    Cancelar
                  </button>
                  <button 
                    className="btn-confirm-password"
                    onClick={confirmarResetPassword}
                  >
                    Confirmar Reset
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionUsuariosPage;